import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { User } from '../../common/model/user';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient) {}

  findAll(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/users`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findOne(id: string): Observable<any> {
    const url = `${environment.url.api}/users/${id}`;
    return this.http.get<User>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  findByEmail(email: string): Observable<any> {
    const url = `${environment.url.api}/users`;
    const params: HttpParams = new HttpParams().set('email', email);
    return this.http.get<User>(url, {params : params}).pipe(timeout(environment.config.apiWaitingTime));
  }

  create(user: User): Observable<any> {
    const url = `${environment.url.api}/users`;
    return this.http.post<User>(url, user).pipe(timeout(environment.config.apiWaitingTime));
  }

  save(user: User): Observable<any> {
    const url = `${environment.url.api}/users/${user.id}`;
    return this.http.put<User>(url, user).pipe(timeout(environment.config.apiWaitingTime));
  }

  delete(id: string): Observable<any> {
    const url = `${environment.url.api}/users/${id}`;
    return this.http.delete<User>(url).pipe(timeout(environment.config.apiWaitingTime));
  }
}
